const VOTE_STATE = {
  NOT_VOTED: 'NOT_VOTED',
  VOTED: 'VOTED',
  REJECTED: 'REJECTED',
  ILL: 'ILL'
};

export default VOTE_STATE;
